



































































































































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { doublePrevention, hiddenDangerLibraryServer } from '@/api/installServer';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import publishObjectPath from '@/util/configRegistry'; // 导入过渡函数

@Component({
  components: { CollapseTransition },
})
export default class DialogDetail2 extends Vue {
  private dialogVisible = false;
  // 表单数据
  private formData: any = {};

  private basicInfoShow: any = true;
  private rectifyInfoShow: any = true;
  private logInfoShow: any = true;
  imgPath: any = publishObjectPath.imgPathWater;

  private showDialog(data: any) {
    this.getData(data.id);
    this.dialogVisible = true;
  }
  private getData(id: any) {
    hiddenDangerLibraryServer
      .getHazardManageDetail(id)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  handleClose(done: any) {
    done();
  }
}
